import { StyleSheet } from 'react-native-web';
import { colors } from '../../global-styles';

/**
 * @typedef {object} SwitchStyleProps
 * @property {string} activeThumbColor - circle component
 * @property {string} activeTrackColor - track component
 */

/**
 * @typedef {object} SwitchStyles
 * @property {SwitchStyleProps} default
 */
export const SwitchStyles = {
  default: {
    activeThumbColor: colors.brandPrimary,
    activeTrackColor: colors.brandTertiary,
  },
};

const styles = StyleSheet.create({
  switchBody: {
    display: 'flex',
  },
});

export default styles;
